import React, { ReactElement } from "react";

import { Stack, Typography } from "@mui/material";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";

import BasicSelector from "../../../../components/Redux/BasicSelector";
import SettingSection from "../../../../components/SettingSection";
import {
  getSettingsFormProperty,
  setSettingsFormError,
  setSettingsFormProperty,
} from "../../../../slices/settings";
import { SectionProps } from "../../../routes/components/edit_sections/common";
import LogFields from "../LogFields";
import { LogLevelOptions } from "../LogLevelOptions";
import { ReduxTextField } from "@/components/Redux/TextField";
import ipPort from "@/validators/ipPort";

export const Logging = ({
  readonly,
  tabValue,
  refresh,
}: SectionProps): ReactElement => {
  return (
    <Container component={Paper} maxWidth={false} disableGutters={true}>
      <Stack key={tabValue + refresh} spacing={1} sx={{ m: 3 }}>
        <Typography id={tabValue} variant="h2" sx={{ pt: 2 }}>
          Logging
        </Typography>
        <Divider />
        <SettingSection label="Metrics Address" docsKey="metrics-address">
          <ReduxTextField
            disabled={readonly}
            setter={setSettingsFormProperty}
            getter={getSettingsFormProperty}
            errorHandler={setSettingsFormError}
            path="metricsAddress"
            validator={ipPort}
            fullWidth
          />
        </SettingSection>
        <Divider />

        <SettingSection label="Log Level" docsKey="log-level">
          <BasicSelector
            path="logLevel"
            options={LogLevelOptions}
            setter={setSettingsFormProperty}
            getter={getSettingsFormProperty}
            errorHandler={setSettingsFormError}
            readonly={readonly}
          />
        </SettingSection>
        <Divider />

        <SettingSection label="Proxy Log Level" docsKey="proxy-log-level">
          <BasicSelector
            path="proxyLogLevel"
            options={LogLevelOptions}
            setter={setSettingsFormProperty}
            getter={getSettingsFormProperty}
            errorHandler={setSettingsFormError}
            readonly={readonly}
          />
        </SettingSection>
        <Divider />

        <SettingSection label="Access Log Fields" docsKey="access-log-fields">
          <LogFields field="accessLogFields" disabled={readonly} />
        </SettingSection>

        <Divider />

        <SettingSection
          label="Authorize Log Fields"
          docsKey="authorize-log-fields"
        >
          <LogFields field="authorizeLogFields" disabled={readonly} />
        </SettingSection>
      </Stack>
    </Container>
  );
};
